import React, { Component } from 'react';
import { Content, Button } from 'bulma-react'
import marked from 'marked';

class BlogContent extends Component {
  constructor(props) {
    super(props);
    const { opened } = props;
    this.state = {
      showMore: !!opened
    };
  }
  loadMore = (e) => {
    e.preventDefault();
    const { blog } = this.props;
    this.props.loadMore(blog._id || blog.name);
    this.setState({ showMore: !this.state.showMore });
  };
  onEdit = (e) => {
    e.preventDefault();
    const { blog } = this.props;
    this.props.onEdit(blog._id || blog.name);
  };
  render() {
    const { blog, onEdit } = this.props;
    const { showMore } = this.state;
    const { markDown, preview, hasDetail } = blog || {};
    const isMore = showMore && markDown;
    const src = isMore ? markDown : preview || '';
    const str = marked.parse(src, { sanitize: true });
    return (
      <div>
        <div className="is-pulled-right" style={{
          marginTop: '-0.5rem',
        }}>
          <Button is-link is-small onClick={ this.onEdit }>
            edit
          </Button>
        { hasDetail &&
          <Button is-link is-small onClick={ this.loadMore }>
          { isMore ? 'less' : 'more' }
          </Button> }
        </div>
        <Content {...{'is-small': !isMore}} style={{
        }}
        dangerouslySetInnerHTML={{ __html: str }} />
      </div>
    );
  }
}

export default BlogContent;




// WEBPACK FOOTER //
// ./src/components/BlogContent.js